import React from 'react';
import { SpinProps } from 'antd';

import { StyledAntdSpinner } from './style';

const CVSpinner = (props: SpinProps): JSX.Element => (
  <StyledAntdSpinner {...props} />
);

export default CVSpinner;
